<template>
  <home></home>
</template>

<script>
import Home from "./_components/new-home.vue";
import formTemplateStore from "../FormTemplate/_store";

/**
 * @module ManageJob
 * @description manage job module
 */
export default {
  /**
   * @memberof module:ManageJob
   * @namespace components
   * @description components of manage job module
   */
  components: {
    Home,
  },
  created() {
    const FORM_TEMPLATE_STORE_KEY = "$_form_template";
    if (!(FORM_TEMPLATE_STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(FORM_TEMPLATE_STORE_KEY, formTemplateStore);
    }
  },
};
</script>
